export default __webpack_public_path__ + "4124f6bd6e215822b541199f661a41ad.svg";